<template>
    <div
        v-bind="$attrs"
        class="w-full h-[2px] bg-muted-foreground"
    />
</template>
